import React, { useState } from 'react';
import { Snackbar, Alert } from '@mui/material';
import {
    MainGrid,
    OverviewSection,
    AssignmentSection
} from '../../styles/CalculateMoney/CalculateMoneyViewStyles';
import OverviewPanel from './OverviewPanel';
import AssignmentPanel from './AssignmentPanel';

const CalculateMoneyView = ({ businessId, workSessions, earningsSummary, staff, currentWeek, services, categories }) => {
    const [successMessage, setSuccessMessage] = useState('');
    const handleShowSuccess = (msg) => setSuccessMessage(msg);
    return (
        <MainGrid>
            <OverviewSection>
                <OverviewPanel
                    businessId={businessId}
                    currentWeek={currentWeek}
                    workSessions={workSessions}
                    staff={staff}
                    services={services}
                    categories={categories}
                    onShowSuccess={handleShowSuccess}
                />
            </OverviewSection>
            <AssignmentSection>
                <AssignmentPanel
                    staff={staff}
                    businessId={businessId}
                    onShowSuccess={handleShowSuccess}
                      workSessions={workSessions}
                />
            </AssignmentSection>

            <Snackbar
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                open={!!successMessage}
                autoHideDuration={5000}
                onClose={() => setSuccessMessage('')}
                sx={{ mt: '70px' }} 
            >
                <Alert
                    onClose={() => setSuccessMessage('')}
                    severity="success"
                    sx={{ width: '100%' }}
                >
                    {successMessage}
                </Alert>
            </Snackbar>
        </MainGrid>
    );
};

export default CalculateMoneyView;